(() => {
  const mountHomepageSearch = () => {
    const header = document.querySelector('.header.header--top-left');
    if (!header || header.querySelector('.hk-header-search')) return;

    const icons = header.querySelector('.header__icons');
    if (!icons) return;

    const form = document.createElement('form');
    form.className = 'hk-header-search';
    form.setAttribute('role', 'search');
    form.setAttribute('method', 'get');
    form.setAttribute('action', '/search');

    form.innerHTML = `
      <div class="hk-header-search__field">
        <label class="visually-hidden" for="HkHeaderSearch">Ürün, marka veya kategori ara</label>
        <input
          id="HkHeaderSearch"
          class="hk-header-search__input"
          type="search"
          name="q"
          placeholder="Ürün, marka veya kategori ara..."
          autocomplete="off"
          enterkeyhint="search"
        >
        <button class="hk-header-search__button" type="submit" aria-label="Ara">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="11" cy="11" r="6.75" stroke-width="1.6"></circle>
            <path d="M16 16L20.2 20.2" stroke-width="1.6" stroke-linecap="round"></path>
          </svg>
        </button>
      </div>
    `;

    header.insertBefore(form, icons);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountHomepageSearch, { once: true });
  } else {
    mountHomepageSearch();
  }
})();
